export enum IntentType {
  READ = 'READ',
  FILL = 'FILL',
  SIGN = 'SIGN',
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  ANNOTATE = 'ANNOTATE',
  COMPOSE = 'COMPOSE',
  SELF_SERVE = 'SELF_SERVE',
}

export const DefaultFieldRules = 'DEFAULT';

export const AllFieldPermissions = 'ALL';

export enum FieldPermission {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  POSITION = 'POSITION',
  ASSIGNMENT = 'ASSIGNMENT',
  LABEL = 'LABEL',
  APPEARANCE = 'APPEARANCE',
  HELP = 'HELP',
  CONDITION = 'CONDITION',
  VALUE = 'VALUE',
  MATERIAL = 'MATERIAL',
  LINKED_FIELDS = 'LINKED_FIELDS',
}

export enum EditorApp {
  Default = 'DEFAULT',
  SelfServe = 'SELF_SERVE',
  TemplateEditor = 'TEMPLATE_EDITOR',
  Annotation = 'ANNOTATION',
  OrganizePages = 'ORGANIZE_PAGES',
}

export enum EditorMode {
  Edit = 'EDIT',
  Read = 'READ',
  Fill = 'FILL',
}

export enum FieldType {
  Signature = 'SIGNATURE',
  Initial = 'INITIAL',
  Text = 'TEXT',
  Date = 'DATE',
  Time = 'TIME',
  DateTime = 'DATETIME',
  Radio = 'RADIO',
  Checkbox = 'CHECKBOX',
  Dropdown = 'DROPDOWN',
  Strike = 'STRIKE',
  Note = 'NOTE',
  Image = 'IMAGE',
}

export enum ReadinessInfoState {
  InProgress = 'IN_PROGRESS',
  Ready = 'READY',
  Failed = 'FAILED',
}

export const ZDOCS_REQUEST_ID_HEADER = 'x-zdocs-request-id';
